/* ============================================================================
   kaufweise Cookie-Consent — Integrations-Layer
   Treibt die vendored Engine vanilla-cookieconsent 3.1.0 (window.CookieConsent)
   und bridged sie an:
     (a) Shopify Customer Privacy API  -> Layer 1 (app-verwalteter Pixel)
     (b) Google Consent Mode v2 (gtag) -> Layer 2 (theme-eigene Modeling-ID) + PageFly-gtag
   Config/i18n kommen aus window.KW_CONSENT (vom Snippet aus Shopify-Locales gerendert).
   Der frühe <head>-Snippet setzt bereits gtag('consent','default',...) synchron
   aus dem kw_consent-Cookie (Persistenz-Replay-Fix) — hier laufen nur UPDATES.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.KW_CONSENT || {};
  var I18N = CFG.i18n || {};

  /* ---- Eine Wahrheitsquelle für Tracking-Cookie-Muster (CC-Autoclear + aktives Löschen) ---- */
  var COOKIE_PATTERNS = {
    analytics: [/^_ga/, /^_gid/, /^_gat/],
    // inkl. theme-eigener Ads-Click-ID/UTM-Cookies (kw-gclid-capture) -> bei Marketing-Ablehnung löschen
    marketing: [/^_gcl/, /^_gac/, /^_fb/, /^_ttp/, /^_tt_/, /^_kw_gclid/, /^_kw_utm_/]
  };

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* ---- Google Consent Mode v2: aus CC-Kategorien ableiten ---------------- */
  function gtagUpdateFromCategories() {
    var cc = window.CookieConsent;
    var analytics = cc.acceptedCategory('analytics');
    var marketing = cc.acceptedCategory('marketing');
    var prefs = cc.acceptedCategory('preferences');
    var g = window.gtag;
    if (typeof g === 'function') {
      // KEINE window['ga-disable-…']-Flags setzen: G&Y-App-Pixel laeuft im selben
      // window (runtimeContext OPEN) und teilt die gtag-Instanz — Flags wuerden
      // auch dessen Observed-Hits killen (verifizierte Regression 17.07.).
      g('consent', 'update', {
        analytics_storage: analytics ? 'granted' : 'denied',
        ad_storage: marketing ? 'granted' : 'denied',
        ad_user_data: marketing ? 'granted' : 'denied',
        ad_personalization: marketing ? 'granted' : 'denied',
        functionality_storage: prefs ? 'granted' : 'denied',
        personalization_storage: prefs ? 'granted' : 'denied',
        security_storage: 'granted'
      });
      // Bei fehlender Marketing-Einwilligung: keine Klick-IDs/Cookie-Dekoration weitergeben
      g('set', 'ads_data_redaction', marketing ? false : true);
    }
    return { analytics: analytics, marketing: marketing, prefs: prefs };
  }

  /* ---- Shopify Customer Privacy API: Layer-1-Pixel gaten ----------------- */
  function shopifyApplyConsent(state) {
    if (!(window.Shopify && typeof window.Shopify.loadFeatures === 'function')) return;
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (err) {
        if (err) return;
        // setTimeout(0) INNERHALB des Callbacks entkoppelt den Race beim ersten
        // consent-tracking-api-Load (Fallstrick: setTrackingConsent zu früh = no-op).
        setTimeout(function () {
          try {
            var cp = window.Shopify.customerPrivacy;
            if (!cp || typeof cp.setTrackingConsent !== 'function') return;

            var next = {
              analytics: !!state.analytics,
              marketing: !!state.marketing,
              preferences: !!state.prefs,
              sale_of_data: !!state.marketing
            };

            // Bestehenden Shopify-State lesen und nur bei Abweichung schreiben
            // ("" = unentschieden -> unsere Wahl pushen; identisch -> nicht stur überschreiben).
            var cur = {};
            try { cur = cp.currentVisitorConsent() || {}; } catch (e) {}
            var same =
              cur.analytics === (next.analytics ? 'yes' : 'no') &&
              cur.marketing === (next.marketing ? 'yes' : 'no') &&
              cur.preferences === (next.preferences ? 'yes' : 'no');
            if (same) return;

            cp.setTrackingConsent(next, function () {});
          } catch (e) { /* API-Form kann je Shop-Region variieren — nie hart failen */ }
        }, 0);
      }
    );
  }

  /* ---- Zentrale Sync-Routine bei jeder Entscheidung ---------------------- */
  function syncConsent() {
    var state = gtagUpdateFromCategories();
    shopifyApplyConsent(state);
    // Reject-Härtung: verwaiste Tracking-Cookies aktiv entfernen (gleiche Muster wie CC-Autoclear)
    if (!state.analytics) eraseByPatterns(COOKIE_PATTERNS.analytics);
    if (!state.marketing) eraseByPatterns(COOKIE_PATTERNS.marketing);
    // Fable-Review 17.07.: Bei Revoke auch Cart-Attribute leeren, sonst meldet der
    // Order-Relay spaeter veraltete Einwilligungs-Signale (gclid=Marketing-Evidenz).
    try {
      var clearKeys = [];
      if (!state.marketing) clearKeys = clearKeys.concat(['gclid','utm_source','utm_medium','utm_campaign','utm_content','utm_term']);
      if (!state.analytics) clearKeys = clearKeys.concat(['_kw_ga_cid','_kw_ga_sid']);
      if (clearKeys.length && document.cookie.indexOf('cart=') > -1) {
        var cfd = new FormData();
        clearKeys.forEach(function(k){ cfd.append('attributes[' + k + ']', ''); });
        fetch('/cart/update.js', { method:'POST', body: cfd, credentials:'include' }).catch(function(){});
      }
    } catch (e) {}
  }

  function eraseByPatterns(patterns) {
    var host = location.hostname;
    var domains = ['', host, '.' + host];
    var dot = host.split('.');
    if (dot.length > 2) domains.push('.' + dot.slice(-2).join('.'));
    document.cookie.split(';').forEach(function (c) {
      var name = c.split('=')[0].trim();
      if (!name) return;
      var hit = patterns.some(function (re) { return re.test(name); });
      if (!hit) return;
      domains.forEach(function (d) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/' + (d ? '; domain=' + d : '');
      });
    });
  }

  /* ---- DOM-Helfer: textContent (kein innerHTML) für Defense-in-Depth ------ */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ---- DOM-Injektion: Mascot-Bühne + Eyebrow + Extra-Links ---------------
     onModalReady liefert { modalName, modal } — `modal` IST das (noch detachte)
     Modal-Element (.cm bzw. .pm), BEVOR #cc-main am <body> hängt. Deshalb hier
     direkt auf `modal` arbeiten statt document.querySelector('#cc-main …'). */
  function decorateConsentModal(cm) {
    if (!cm || cm.querySelector('.kw-cm-stage')) return;

    // Mascot-Bühne (links) — reines Weiß, Mascot poppt frei
    var stage = el('div', 'kw-cm-stage');
    stage.setAttribute('aria-hidden', 'true');
    ['s1', 's2', 's3', 's4'].forEach(function (s) { stage.appendChild(el('span', 'kw-spark ' + s)); });
    if (CFG.mascotUrl) {
      var img = document.createElement('img');
      img.className = 'kw-cm-stage__img';
      img.src = CFG.mascotUrl;
      img.width = 1000; img.height = 1144;
      img.alt = '';
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'async');
      stage.appendChild(img);
    }
    cm.insertBefore(stage, cm.firstChild);

    // Eyebrow vor dem Titel
    var texts = cm.querySelector('.cm__texts');
    if (texts && I18N.eyebrow) {
      texts.insertBefore(el('span', 'kw-eyebrow', I18N.eyebrow), texts.firstChild);
    }

    // Extra-Block: Einstellungen-Link + Legal (in .cm__body, nach den Buttons)
    var body = cm.querySelector('.cm__body');
    if (body && !body.querySelector('.kw-cm-extra')) {
      var extra = el('div', 'kw-cm-extra');
      var row = el('div', 'kw-settings-row');
      var link = el('button', 'kw-settings-link', I18N.settings || 'Einstellungen');
      link.type = 'button';
      link.setAttribute('data-cc', 'show-preferencesModal');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', function (e) { e.preventDefault(); window.CookieConsent.showPreferences(); });
      row.appendChild(link);
      extra.appendChild(row);
      extra.appendChild(buildLegal('kw-legal'));
      body.appendChild(extra);
    }
  }

  function decoratePreferencesModal(pm) {
    if (!pm) return;

    // Header: Eyebrow + Titel + Desc in EINE Textspalte bündeln, damit sie im
    // Base-Lib-Flex(space-between)-Header nicht mit dem Close-Button kollidieren.
    var header = pm.querySelector('.pm__header');
    var title = header && header.querySelector('.pm__title');
    if (header && title && !header.querySelector('.kw-pm-txt')) {
      var txt = el('div', 'kw-pm-txt');
      header.insertBefore(txt, title);
      if (I18N.pref_eyebrow) txt.appendChild(el('span', 'kw-pm-eyebrow', I18N.pref_eyebrow));
      txt.appendChild(title); // vorhandenen Titel in die Spalte verschieben
      if (I18N.pref_description) txt.appendChild(el('p', 'kw-pm-desc', I18N.pref_description));
      if (CFG.mascotUrl) {
        var img = document.createElement('img');
        img.className = 'kw-pm-mascot';
        img.src = CFG.mascotUrl;
        img.width = 1000; img.height = 1144;
        img.alt = '';
        img.setAttribute('loading', 'lazy');
        header.appendChild(img);
      }
    }

    // "Immer aktiv"-Badge an die Notwendig-Titelzeile (robust über [data-category]).
    if (I18N.cat_necessary_badge) {
      var necTitle = null;
      var necCat = pm.querySelector('[data-category="necessary"]');
      if (necCat) {
        var sec = (necCat.closest && necCat.closest('.pm__section')) || necCat;
        necTitle = sec.querySelector('.pm__section-title');
      }
      if (!necTitle) necTitle = pm.querySelector('.pm__section-title'); // Fallback: erste Sektion = Notwendig
      if (necTitle && !necTitle.querySelector('.kw-badge')) {
        necTitle.appendChild(el('span', 'kw-badge', I18N.cat_necessary_badge));
      }
    }

    // Footer: die 3 Buttons aus den 2 Base-Lib-.pm__btn-group in EINE flache Reihe
    // holen (Reihenfolge: Ablehnen | Speichern | Akzeptieren), Legal-Zeile darunter.
    var footer = pm.querySelector('.pm__footer');
    if (footer && !footer.querySelector('.kw-pm-actions')) {
      var actions = el('div', 'kw-pm-actions');
      ['necessary', 'save', 'all'].forEach(function (role) {
        var b = footer.querySelector('.pm__btn[data-role="' + role + '"]');
        if (b) actions.appendChild(b);
      });
      footer.insertBefore(actions, footer.firstChild);
      footer.appendChild(buildLegal('kw-pm-legal'));
    }
  }

  function buildLegal(cls) {
    var nav = document.createElement('nav');
    nav.className = cls;
    nav.setAttribute('aria-label', I18N.legal_aria || 'Rechtliches');
    if (CFG.privacyUrl) {
      var a1 = document.createElement('a');
      a1.href = CFG.privacyUrl; a1.textContent = I18N.privacy || 'Datenschutzerklärung';
      nav.appendChild(a1);
    }
    if (CFG.privacyUrl && CFG.imprintUrl) nav.appendChild(el('span', 'kw-dot'));
    if (CFG.imprintUrl) {
      var a2 = document.createElement('a');
      a2.href = CFG.imprintUrl; a2.textContent = I18N.imprint || 'Impressum';
      nav.appendChild(a2);
    }
    return nav;
  }

  /* ---- CC-Konfiguration bauen -------------------------------------------- */
  function autoClearFor(patterns) {
    return { cookies: patterns.map(function (re) { return { name: re }; }) };
  }

  function buildTranslation() {
    return {
      consentModal: {
        // title/description enthalten Markup (_html-Locale-Key) -> CC rendert via innerHTML
        title: I18N.title || '',
        description: I18N.description || '',
        acceptAllBtn: I18N.accept_all || 'Alle akzeptieren',
        acceptNecessaryBtn: I18N.reject_all || 'Alle ablehnen'
      },
      preferencesModal: {
        title: I18N.pref_title || 'Cookie-Einstellungen',
        acceptAllBtn: I18N.accept_all || 'Alle akzeptieren',
        acceptNecessaryBtn: I18N.reject_all || 'Alle ablehnen',
        savePreferencesBtn: I18N.save || 'Auswahl speichern',
        closeIconLabel: I18N.close || 'Schließen',
        sections: [
          // Intro-Beschreibung liegt im Header (.kw-pm-txt), NICHT als Body-Sektion.
          { title: I18N.cat_necessary_title || 'Notwendig', description: I18N.cat_necessary_desc || '', linkedCategory: 'necessary' },
          { title: I18N.cat_analytics_title || 'Analyse', description: I18N.cat_analytics_desc || '', linkedCategory: 'analytics' },
          { title: I18N.cat_marketing_title || 'Marketing', description: I18N.cat_marketing_desc || '', linkedCategory: 'marketing' },
          { title: I18N.cat_preferences_title || 'Präferenzen', description: I18N.cat_preferences_desc || '', linkedCategory: 'preferences' }
        ]
      }
    };
  }

  /* ---- Shopify -> gtag spiegeln (anderer Tab / Checkout / POS) ------------ */
  function reflectShopifyToGtag(detail) {
    var g = window.gtag;
    if (typeof g !== 'function' || !detail) return;
    g('consent', 'update', {
      analytics_storage: detail.analyticsAllowed ? 'granted' : 'denied',
      ad_storage: detail.marketingAllowed ? 'granted' : 'denied',
      ad_user_data: detail.marketingAllowed ? 'granted' : 'denied',
      ad_personalization: detail.marketingAllowed ? 'granted' : 'denied',
      functionality_storage: detail.preferencesAllowed ? 'granted' : 'denied',
      personalization_storage: detail.preferencesAllowed ? 'granted' : 'denied',
      security_storage: 'granted'
    });
    g('set', 'ads_data_redaction', detail.marketingAllowed ? false : true);
  }

  function init() {
    if (!window.CookieConsent || typeof window.CookieConsent.run !== 'function') return;
    var lang = (CFG.lang || document.documentElement.lang || 'de').toLowerCase().split('-')[0];
    var translations = {};
    translations[lang] = buildTranslation();

    window.CookieConsent.run({
      autoShow: CFG.suppressModal ? false : true,
      disablePageInteraction: true,   // Cookie-Wall: kein Interagieren bis Wahl
      manageScriptTags: false,        // gtag/Pixel steuern wir selbst
      autoClearCookies: true,         // erfasste Cookies bei Widerruf löschen
      hideFromBots: true,
      revision: CFG.revision || 1,    // Re-Consent bei Policy-Änderung
      cookie: {
        name: 'kw_consent',           // muss zum <head>-Early-Reader passen
        expiresAfterDays: 182,
        sameSite: 'Lax'
      },
      guiOptions: {
        consentModal: { layout: 'box', position: 'middle center', equalWeightButtons: true, flipButtons: false },
        preferencesModal: { layout: 'box', equalWeightButtons: true, flipButtons: false }
      },
      categories: {
        necessary: { enabled: true, readOnly: true },
        analytics: { autoClear: autoClearFor(COOKIE_PATTERNS.analytics) },
        marketing: { autoClear: autoClearFor(COOKIE_PATTERNS.marketing) },
        preferences: {}
      },
      language: {
        default: lang,
        translations: translations
      },
      onFirstConsent: syncConsent,
      onConsent: syncConsent,
      onChange: syncConsent,
      onModalReady: function (p) {
        if (!p) return;
        if (p.modalName === 'consentModal') decorateConsentModal(p.modal);
        if (p.modalName === 'preferencesModal') decoratePreferencesModal(p.modal);
      }
    });

    // Öffentlicher Hook für Footer-Link + Floating-Pill (Widerruf, Art. 7 Abs. 3)
    window.kwConsentOpen = function () { window.CookieConsent.showPreferences(); };

    // Bidirektional: Shopify-seitige Consent-Änderung (anderer Tab/Checkout/POS) -> gtag spiegeln
    document.addEventListener('visitorConsentCollected', function (e) { reflectShopifyToGtag(e && e.detail); });
  }

  ready(init);
})();

